import * as S from './styles'

const DefEx = () => {
  const handleDefEx = () => {
    window.location.href = '/defex'
  }

  return (
    <S.DefExStyled>
      <button type='button' onClick={handleDefEx}>DefEx</button>
    </S.DefExStyled>
  )
}

export default DefEx
